import { motion } from "framer-motion";

export const BottomTabBar = ({ activeTab, onTabChange, previewEnabled, disabled }) => {
  return (
    <div className="gm-tab-bar">
      <div className="gm-tab-bar-inner">
        <button
          onClick={() => !disabled && onTabChange("chat")}
          disabled={disabled}
          className={`gm-tab-btn ${activeTab === "chat" ? "gm-tab-btn--active" : disabled ? "gm-tab-btn--disabled" : "gm-tab-btn--inactive"}`}
        >
            <motion.div layoutId="tab-indicator" className="gm-tab-indicator" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M2.99194 16.342C3.13897 16.7129 3.17171 17.1193 3.08594 17.509L2.02094 20.799C1.98662 20.9658 1.99549 21.1387 2.04671 21.3011C2.09793 21.4636 2.1898 21.6103 2.3136 21.7273C2.43741 21.8443 2.58904 21.9277 2.75413 21.9697C2.91923 22.0116 3.0923 22.0107 3.25694 21.967L6.66994 20.969C7.03765 20.8961 7.41846 20.9279 7.76894 21.061C9.90432 22.0582 12.3233 22.2692 14.5991 21.6567C16.8749 21.0442 18.8612 19.6477 20.2076 17.7134C21.5541 15.7791 22.1741 13.4314 21.9582 11.0845C21.7424 8.73769 20.7046 6.54247 19.028 4.88619C17.3514 3.22992 15.1436 2.21904 12.7943 2.0319C10.445 1.84475 8.10507 2.49338 6.18738 3.86334C4.26968 5.23329 2.89747 7.23654 2.31283 9.51964C1.72819 11.8027 1.9687 14.219 2.99194 16.342Z"
              stroke="#E6FF00"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="gm-tab-label">Wizard</span>
        </button>

        <button
          onClick={() => previewEnabled && !disabled && onTabChange("preview")}
          className={`gm-tab-btn ${
            activeTab === "preview"
              ? "gm-tab-btn--active"
              : previewEnabled && !disabled
                ? "gm-tab-btn--inactive"
                : "gm-tab-btn--disabled"
          }`}
          disabled={!previewEnabled || disabled}
        >
            <motion.div layoutId="tab-indicator" className="gm-tab-indicator" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21"
              stroke="#777777"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18 17V9"
              stroke="#777777"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13 17V5"
              stroke="#777777"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 17V14"
              stroke="#777777"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="gm-tab-label">Preview</span>
        </button>
      </div>
    </div>
  );
};
